"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_router_dom_1 = require("react-router-dom");
const stats_tile_styled_1 = require("./stats-tile.styled");
exports.StatTile = ({ colour, widthtype = 'normal', titlePos, symbol, firstLabel, secondLabel, to }) => {
    const classes = ['stat-tile'];
    classes.push(`stat-tile__width--${widthtype}`);
    classes.push(`stat-tile__${colour}`);
    return React.createElement(stats_tile_styled_1.default, null,
        React.createElement("div", { className: classes.join(' ') }, !to ?
            React.createElement("div", { className: "stat-tile__row" },
                titlePos !== 'bottom' && React.createElement("div", { className: "stat-tile__symbol" }, symbol),
                React.createElement("div", { className: "stat-tile__first-label" }, firstLabel),
                React.createElement("div", { className: "stat-tile__second-label" }, secondLabel),
                titlePos === 'bottom' && React.createElement("div", { className: "stat-tile__symbol" }, symbol)) :
            React.createElement(react_router_dom_1.Link, { className: "stat-tile__link", to: to },
                React.createElement("div", { className: "stat-tile__row" },
                    React.createElement("div", { className: "stat-tile__link__symbol" }, symbol),
                    React.createElement("div", { className: "stat-tile__link__first-label" }, firstLabel),
                    React.createElement("div", { className: "stat-tile__link__second-label" }, secondLabel),
                    React.createElement("div", { className: "stat-tile__link__arrow" },
                        React.createElement("span", null, "\u2304"))))));
};
var StatTitlePosition;
(function (StatTitlePosition) {
    StatTitlePosition["TOP"] = "top";
    StatTitlePosition["BOTTOM"] = "bottom";
})(StatTitlePosition = exports.StatTitlePosition || (exports.StatTitlePosition = {}));
var StatTileColours;
(function (StatTileColours) {
    StatTileColours["RED"] = "red";
    StatTileColours["GREEN"] = "green";
    StatTileColours["BLUE"] = "blue";
})(StatTileColours = exports.StatTileColours || (exports.StatTileColours = {}));
var WidthType;
(function (WidthType) {
    WidthType["NARROW"] = "narrow";
    WidthType["NORMAL"] = "normal";
    WidthType["WIDE"] = "wide";
})(WidthType = exports.WidthType || (exports.WidthType = {}));
//# sourceMappingURL=StatTile.js.map